/**
 * オーサリングシーケンスエラー種別
 */
export var SequenceErrors;

(function (SequenceErrors) {
  /**
   * エラーなし
   */
  SequenceErrors[SequenceErrors["NoError"] = 0] = "NoError";
  /**
   * アイテム未選択
   */

  SequenceErrors[SequenceErrors["NoItemsSelected"] = 1] = "NoItemsSelected";
  /**
   * 同一アイテム選択
   */

  SequenceErrors[SequenceErrors["SameItemsSelected"] = 2] = "SameItemsSelected";
  /**
   * 初期トリガー選択エラー
   */

  SequenceErrors[SequenceErrors["TriggerSelectionErrorInFirstSequence"] = 3] = "TriggerSelectionErrorInFirstSequence";
})(SequenceErrors || (SequenceErrors = {}));